import React from 'react';

const Banner = () => {
    return (
        <div className='site-banner'>
            <div className='banner-info-container'>
                <h1>WELCOME</h1>
                <h2> INVENTO WAREHOUSE</h2>
                <div className="banner-info">
                    <h3 className='first-one'>Make it Easy</h3>
                    <h3 className='second-one'>Take it Easy</h3>
                </div>
            </div>
        </div>
    );
};

export default Banner;